//  Time-stamp: "2016-07-25 06:41:36 MDT"
module.exports = [
'AUM', "", "", "", "", "", "", "", " // ", " * ", "", "-", " / ", " / ", " // ", " -/ ",
" +/ ", " X/ ", " /XX/ ", " /X/ ", ", ", "", "", "", "", "", "", "", "", "", "", "",
'0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ".5", "1.5", "2.5", "3.5", "4.5", "5.5",
"6.5", "7.5", "8.5", "-.5", "+", "*", "^", "_", "", "~", '[?]', "]", "[[", "]]", "", "",
'k', 'kh', 'g', 'gh', 'ng', 'c', 'ch', 'j', '[?]', 'ny', 'tt', 'tth', 'dd', 'ddh', 'nn', 't',
'th', 'd', 'dh', 'n', 'p', 'ph', 'b', 'bh', 'm', 'ts', 'tsh', 'dz', 'dzh', 'w', 'zh', 'z',
"'", 'y', 'r', 'l', 'sh', 'ssh', 's', 'h', 'a', 'kss', 'r', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', 'aa', 'i', 'ii', 'u', 'uu', 'R', 'RR', 'L', 'LL', 'e', 'ee', 'o', 'oo', 'M', 'H',
'i', 'ii', "", "", "", "", "", "", "", "", "", "", '[?]', '[?]', '[?]', '[?]',
'k', 'kh', 'g', 'gh', 'ng', 'c', 'ch', 'j', '[?]', 'ny', 'tt', 'tth', 'dd', 'ddh', 'nn', 't',
'th', 'd', 'dh', 'n', 'p', 'ph', 'b', 'bh', 'm', 'ts', 'tsh', 'dz', 'dzh', 'w', 'zh', 'z',
"'", 'y', 'r', 'l', 'sh', 'ss', 's', 'h', 'a', 'kss', 'w', 'y', 'r', '[?]', 'X', " :X: ",
" /O/ ", " /o/ ", " \\\\o\\\\ ", " (O) ", "", "", "", "", "", "", "", "", "", '[?]', '[?]', "",
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
];
